import { BuilderCatalogClass } from '../types/enums/BuilderCatalogClass.enum';
import { BuilderCharacteristic } from '../types/enums/BuilderCharacteristic.enum';
import { SsbCharacteristic } from '../types/SimilarlySituated/SsbCharacteristic.type';

const SSB_CHARACTERISTICS: SsbCharacteristic[] = [
  {
    id: BuilderCharacteristic.SPECIFIC_STATUTE,
    label: 'Specific statute',
    conditionClass: BuilderCatalogClass.STATUTE_IDENTITY,
    stageMode: 'select',
    statuteKind: 'charge',
    facets: { statuteLevel: true, position: true, disposition: true },
  },
  {
    id: BuilderCharacteristic.ENHANCEMENT,
    label: 'Enhancement',
    conditionClass: BuilderCatalogClass.STATUTE_IDENTITY,
    stageMode: 'select',
    statuteKind: 'enhancement',
    facets: { disposition: true },
  },
  {
    id: BuilderCharacteristic.OFFENSE_GROUPING,
    label: 'Offense grouping',
    conditionClass: BuilderCatalogClass.CATEGORICAL,
    stageMode: 'hidden',
    groupingVocabulary: 'offence-grouping',
  },
  // not built editors
  { id: BuilderCharacteristic.STRIKE_ALLEGED, label: 'Strike alleged', stageMode: 'hidden' },
  { id: BuilderCharacteristic.PRIOR_ALLEGATION, label: 'Prior allegation — non-strike', stageMode: 'hidden' },
  {
    id: BuilderCharacteristic.CASE_DISPOSITION,
    label: 'Case disposition',
    conditionClass: BuilderCatalogClass.CATEGORICAL,
    stageMode: 'hidden',
    vocabulary: 'disposition',
  },
  {
    id: BuilderCharacteristic.AGE,
    label: 'Age',
    conditionClass: BuilderCatalogClass.CATEGORICAL,
    stageMode: 'hidden',
    vocabulary: 'age',
  },
  {
    id: BuilderCharacteristic.GENDER,
    label: 'Gender',
    conditionClass: BuilderCatalogClass.CATEGORICAL,
    stageMode: 'hidden',
    vocabulary: 'gender',
  },
  {
    id: BuilderCharacteristic.DATE_WINDOW,
    label: 'Date window',
    conditionClass: BuilderCatalogClass.DATE_RANGE,
    stageMode: 'hidden',
    vocabulary: 'date-window-stage',
  },
  {
    id: BuilderCharacteristic.CODEFENDANT,
    label: 'Codefendant',
    conditionClass: BuilderCatalogClass.CATEGORICAL,
    stageMode: 'hidden',
    vocabulary: 'codefendant',
  },
];

const CHARACTERISTICS_BY_ID = new Map(SSB_CHARACTERISTICS.map((characteristic) => [characteristic.id, characteristic]));

export function findCharacteristic(id: number): SsbCharacteristic | undefined {
  return CHARACTERISTICS_BY_ID.get(id);
}
